import React from 'react';
import PropTypes from 'prop-types';

import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import { formattedDate } from 'utils';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '0 -10px 8px',
  },
  title: {
    font: '30px SofiaPro-Bold',
    fontSize: '21px',
    letterSpacing: -0.3,
    marginTop: 5,
    color: theme.palette.secondaryColor,
  },
  detailsContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  heading: {
    color: theme.palette.secondaryColor,
    width: '35%',
    fontWeight: 600,
    fontSize: '17px',
  },
  content: {
    fontSize: '17px',
    width: '65%',
    color: theme.palette.secondaryColor,
  },
  line: {
    background: '#d3d3db',
    height: '1px',
    margin: '18px 0 15px',
  },
}));

const Details = ({ details }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>
        Tournament Details
      </Typography>
      <Box className={classes.line} />
      <Box className={classes.detailsContainer}>
        <Typography className={classes.heading}>
          Sport
        </Typography>
        <Typography className={classes.content}>
          {details?.game_type_display}
        </Typography>
      </Box>
      <Box className={classes.line} />
      <Box className={classes.detailsContainer}>
        <Typography className={classes.heading}>
          Format
        </Typography>
        <Typography className={classes.content}>
          {details?.format_display}
        </Typography>
      </Box>
      <Box className={classes.line} />
      <Box className={classes.detailsContainer}>
        <Typography className={classes.heading}>
          Entry Fee
        </Typography>
        <Typography className={classes.content}>
          {details?.fee_display}
        </Typography>
      </Box>
      <Box className={classes.line} />
      <Box className={classes.detailsContainer}>
        <Typography className={classes.heading}>
          Type
        </Typography>
        <Typography className={classes.content}>
          {details?.weight_display}
        </Typography>
      </Box>
      <Box className={classes.line} />
      <Box className={classes.detailsContainer}>
        <Typography className={classes.heading}>
          Date/Time
        </Typography>
        <Typography className={classes.content}>
          {details?.date_iso8601 && formattedDate(details.date_iso8601)}
        </Typography>
      </Box>
      <Box className={classes.line} />
      <Box className={classes.detailsContainer}>
        <Typography className={classes.heading}>
          Frequency
        </Typography>
        <Typography className={classes.content}>
          {details?.frequency_display}
        </Typography>
      </Box>
      <Box className={classes.line} />
      <Box className={classes.detailsContainer}>
        <Typography className={classes.heading}>
          Notes
        </Typography>
        <Typography className={classes.content}>
          {details?.notes}
        </Typography>
      </Box>
    </Box>
  );
};

Details.propTypes = {
  details: PropTypes.object.isRequired,
};

export default Details;
